<template>
  <WithBackdrop
    :backdrop="data?.fields?.backdrop"
    :class="[$style.config, $style.wrap]"
    :style="data?.fields?.cssOverride as StyleValue"
  >
    <div :class="$style.inner">
      <BaseHeading
        v-if="data?.fields?.header"
        :class="$style.header"
        size="h4"
        as="h2"
      >
        {{ data?.fields?.header }}
      </BaseHeading>
      <MarkedParser
        v-if="data?.fields?.subheader"
        :md="data?.fields?.subheader"
        :class="$style.copy"
      />
      <BaseButton type="button" @click="handleLogin">
        {{ localizedStrings['log-in'] || 'Log In' }}
      </BaseButton>
      <MarkedParser
        v-if="data?.fields?.copy"
        :md="data?.fields?.copy"
        :class="$style.copy"
      />
      <BaseButton type="button" @click="handleLogin">
        {{ localizedStrings['register'] || 'Register' }}
      </BaseButton>
    </div>
  </WithBackdrop>
</template>

<script setup lang="ts">
import type { StyleValue } from 'vue'
import type { TypeContentBlockWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  data: TypeContentBlockWithoutUnresolvableLinksResponse
}>()

const { handleLogin } = useAuthLogin()
const { localizedStrings } = useLocalizedStrings()
</script>

<style lang="scss" module>
.config {
  @include breakpoint-variables(
    '--lblock-wrap-padding',
    (
      base: 40px 20px,
      md: 54px 20px,
    )
  );
}

.wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 66vh;
  padding: var(--lblock-wrap-padding);
}

.inner {
  width: 100%;
  max-width: 400px;
  padding: 20px;
  text-align: center;
  background: var(--white);
  box-shadow: 0 4px 13px rgba(#000, 0.06);
}

.copy {
  margin-top: 20px;
  margin-bottom: 12px;
}
</style>
